exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hotel-name {\n  color: orange;\n  font-size: 18px;\n  font-weight: 500; }\n\n.save {\n  height: 37px; }\n\n.change {\n  font-size: 15px;\n  color: #4c84cc !important;\n  text-decoration: underline !important;\n  font-weight: 500;\n  cursor: pointer; }\n\n.footer {\n  background: none !important; }\n\n.info {\n  background-color: #d3daea;\n  border-radius: 7px;\n  margin-left: 14px; }\n\n.title {\n  font-weight: 600;\n  font-size: 16px; }\n\n.parent-title {\n  font-weight: 600;\n  font-size: 17px;\n  color: orange; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/main/pages/hotel-register-requests/modal/modal.component.scss
// module id = ../../../../../src/app/main/pages/hotel-register-requests/modal/modal.component.scss
// module chunks = main